/**
 * Weirwood
 * Copyright 2019 Baidu Inc. All rights reserved.
 *
 * @file 浏览器头信息插件
 * @author zengxiaohui(zengxiaohui@baidu.com)
 */
import { getGlobal } from '../utils/global';
var global = getGlobal();
var UserAgentPlugin = /** @class */ (function () {
    function UserAgentPlugin() {
        this.name = UserAgentPlugin.id;
    }
    UserAgentPlugin.prototype.setupOnce = function (client) {
        this.client = client;
        this.client.captureUserAgent(this.getUserAgent());
    };
    UserAgentPlugin.prototype.getUserAgent = function () {
        if ('navigator' in global && 'document' in global) {
            return {
                url: global.location.href,
                headers: {
                    'User-Agent': global.navigator.userAgent,
                    'Referrer': global.document.referrer
                }
            };
        }
        return {};
    };
    UserAgentPlugin.id = 'UserAgent';
    return UserAgentPlugin;
}());
export { UserAgentPlugin };
//# sourceMappingURL=UserAgent.js.map